import { pathMatchesPattern } from "@/utils/routing";

export function getModuleUrlFromLocation(pathname: string) {
  if (pathMatchesPattern(pathname, "/workspaces/:workspace_id/modules/")) {
    return pathname.split("/")[4];
  }
  window.console.warn(`WARNING: Unknown Module URL for path "${pathname}"`);
  return null;
}
